/* eslint-disable no-console */
const onIdleAfterDuration = (duration, callback) => {
  let counter = 0;

  const resetInterval = () => {
    counter = 0;
  };

  const timer = setInterval(() => {
    if (counter >= duration && callback) {
      callback();
      document.removeEventListener('mousemove', resetInterval);
      clearInterval(timer);
    } else if (counter >= duration) {
      document.removeEventListener('mousemove', resetInterval);
      clearInterval(timer);
    }
    counter += 1000;
  }, 1000);

  document.addEventListener('mousemove', resetInterval);
};

const onPageExit = (callback) => {
  let prvCx = 0;
  let prvCy = 0;
  let cx = 0;
  let cy = 0;

  const trackMousePosition = (event) => {
    prvCx = cx;
    prvCy = cy;
    cx = event.clientX;
    cy = event.clientY;
    if ((cy > 0 && cy < prvCy && cy < 80) && (cx > 500 && cx > prvCx && (document.body.clientWidth - cx) < 400)) {
      if (callback) {
        callback();
      }
      document.removeEventListener('mousemove', trackMousePosition);
    }
  };

  document.addEventListener('mousemove', trackMousePosition);
};

export {
  onIdleAfterDuration,
  onPageExit,
};
/* eslint-enable no-console */
